import React from "react"
import FullRectangles from '../../static/assets/mobile-footer/full-rectangles.png'
import FullSquares from '../../static/assets/mobile-footer/full-squares.png'
import EmptyRectangles from '../../static/assets/mobile-footer/empty-rectangles.png'
import EmptySquares from '../../static/assets/mobile-footer/empty-squares-png.png'
import * as styles from '../styles/mobWorksFooter.module.css'

function MobWorksFooter({ mailStyle, isMosaic, handleChangeMosaic }) {
  return (
    <div className="mobWorksFooter">
      <div className={styles.logosContainer}>
        <span
          role="button"
          onMouseDown={() => handleChangeMosaic(false)}
          tabIndex="0"
        >
          {isMosaic ? <img className={styles.footerCarLogos} src={EmptyRectangles} alt="Carrusel" /> : <img className={styles.footerCarLogos} src={FullRectangles} alt="Carrusel" />}
        </span>
        <span
          role="button"
          onMouseDown={() => handleChangeMosaic(true)}
          tabIndex="0"
        >
          {isMosaic ? <img className={styles.footerMosLogos} src={FullSquares} alt="Mosaicos" /> : <img className={styles.footerMosLogos} src={EmptySquares} alt="Mosaicos" />}
        </span>
      </div>
      <a href="mailto:hola@randomlab.com.ar" className={mailStyle}>hola@randomlab.com.ar</a>
    </div>
  )
}

export default MobWorksFooter
